import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useTranslation } from 'react-i18next';
import { DELETE_URL } from '@utils/api/endpoints.ts';

export const useDeleteOrganizationLogo = (customerId: number) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const deleteCustomerLogo = async () => {
    try {
      await Axios.delete(
        `${DELETE_URL(customerId.toString()).deleteOrganizationLogo}`
      );
    } catch (error) {
      throw new Error(t('an-error-occurred-while-deleting-the-logo'));
    }
  };

  return useMutation<void, AxiosError<BaseError>>(deleteCustomerLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries(['customerLogo', customerId]);
    },
    useErrorBoundary: false
  });
};
